export const memberCoachKeys = {
    // centerId 미지정 시 3-요소 prefix 를 반환 → 무효화(invalidate)는 이 prefix 로 센터 무관하게 매칭된다.
    list: (memberId: string, centerId?: string) =>
        (centerId
            ? (['memberCoach', 'list', memberId, centerId] as const)
            : (['memberCoach', 'list', memberId] as const)),
};
